module.exports = __webpack_public_path__ + "static/first-65d52c422e053459d099cc4fc88d35a8.jpg";